<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      indexState: "", // 判断是新增还是详情 0新增,1详情
    };
  },
  components: {
    // 公告管理主页
    noticeIndex: () => import("./components/noticeIndex.vue"),
    // 步骤页
    stepIndex: () => import("./components/stepIndex.vue"),
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "noticeIndex";
        case 1:
          return "stepIndex";
      }
      return "page";
    },
  },
  methods: {
    changes(index) {
      if (this.indexState == 0 && this.isActive == 1) {
        this.$children[0].Buriedpoint({
          code: "Notices:notice:add",
          parent_code: "Notices:notice",
        });
      } else if (this.indexState == 1 && this.isActive == 1) {
        this.$children[0].Buriedpoint({
          code: "Notices:notice:detail",
          parent_code: "Notices:notice",
        });
      }
      this.isActive = index;
    },
  },
};
</script>
